// Component preloader to eliminate lazy loading delays
import { lazy } from "react";

// Preload all components that are likely to be navigated to
const preloadComponents = () => {
  // Core navigation components
  const CoPilot = lazy(() =>
    import("../pages/CoPilot").then((module) => ({ default: module.CoPilot }))
  );
  const Attendees = lazy(() =>
    import("../pages/Attendees").then((module) => ({
      default: module.Attendees,
    }))
  );
  const Favorites = lazy(() =>
    import("../pages/Favorites").then((module) => ({
      default: module.Favorites,
    }))
  );
  const Messages = lazy(() =>
    import("../pages/Messages").then((module) => ({ default: module.Messages }))
  );
  const Notifications = lazy(() =>
    import("../pages/Notifications").then((module) => ({
      default: module.Notifications,
    }))
  );
  const Profile = lazy(() =>
    import("../pages/Profile").then((module) => ({ default: module.Profile }))
  );

  // Section components
  const Section = lazy(() =>
    import("../pages/Section").then((module) => ({ default: module.Section }))
  );
  const SectionDetail = lazy(() =>
    import("../pages/SectionDetail").then((module) => ({
      default: module.SectionDetail,
    }))
  );

  // Auth components
  const Login = lazy(() =>
    import("../pages/Login").then((module) => ({ default: module.Login }))
  );
  const Verify = lazy(() =>
    import("../pages/Verify").then((module) => ({ default: module.Verify }))
  );
  const ProfileSetup = lazy(() =>
    import("../pages/ProfileSetup").then((module) => ({
      default: module.ProfileSetup,
    }))
  );

  // Other components
  const Install = lazy(() =>
    import("../pages/Install").then((module) => ({ default: module.Install }))
  );
  const NotificationHandler = lazy(() =>
    import("../pages/NotificationHandler").then((module) => ({
      default: module.default,
    }))
  );

  return {
    CoPilot,
    Attendees,
    Favorites,
    Messages,
    Notifications,
    Profile,
    Section,
    SectionDetail,
    Login,
    Verify,
    ProfileSetup,
    Install,
    NotificationHandler,
  };
};

// Preload components immediately
export const preloadedComponents = preloadComponents();

// Function to preload components in the background
export const preloadAllComponents = () => {
  // Start preloading immediately
  const componentPromises = [
    import("../pages/CoPilot"),
    import("../pages/Attendees"),
    import("../pages/Favorites"),
    import("../pages/Messages"),
    import("../pages/Notifications"),
    import("../pages/Profile"),
    import("../pages/Section"),
    import("../pages/SectionDetail"),
    import("../pages/Login"),
    import("../pages/Verify"),
    import("../pages/ProfileSetup"),
    import("../pages/Install"),
    import("../pages/NotificationHandler"),
  ];

  // Preload all components
  Promise.all(componentPromises)
    .then(() => {
      console.log("All components preloaded successfully");
    })
    .catch((error) => {
      console.warn("Some components failed to preload:", error);
    });
};
